export default __webpack_public_path__ + "static/media/robot-icon-faded-small.10eb017b.svg";